import React from 'react';
import { Link, useTheme } from '@material-ui/core';
import { TaxiCompanyList } from '../../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import { useCautionStyles } from '../Cautions';
import { CURRENT_MILEAGE_CAMPAIGN } from '../../campaign/mileageCampaign';

interface Props {
  /** 仮予約画面で表示するタクシー会社名 */
  companyDisplayName: string,
  /** タクシー会社 */
  company: TaxiCompanyList,
  /** 【AM-1152】マイル増量キャンペーン期間中か */
  isCampaignPeriod?: boolean,
  /** 【AM-1152】通常マイルあり（元々AMC ON）の会社か */
  isOriginalSupported?: boolean,
}

/** AMCマイレージ番号に関する注意事項 */
export const AMCCautionJP: React.FC<Props> = (props: Props) => {
  const theme = useTheme();
  const classes = useCautionStyles(theme);

  const taxiMileHelpURL = "https://www.ana.co.jp/ja/jp/site-help/share/contact/mileage_top.html";

  /**
   * 【AM-1152】マイルに関する注意事項の冒頭部分（可変箇所）。
   * - キャンペーン期間中: マイル増量キャンペーンの文言（通常マイルあり/なしで一部差分）
   * - 期間外: 従来の通常文言
   * 文言の可変値（付与マイル・積算時期）は campaign/mileageCampaign.ts の設定を参照する。
   */
  const renderHead = () => {
    // キャンペーン期間中の文言
    if (props.isCampaignPeriod === true) {
      const isOn = props.isOriginalSupported === true;
      const { leadText, mileRate, bonusAccrualTiming } = CURRENT_MILEAGE_CAMPAIGN.text;

      return (
        <>
          <div className={classes.bold}>{leadText}</div>
          <li>
            キャンペーン期間中に、本画面にてANAマイレージクラブ会員お客様番号（10桁）をご入力後、
            予約・乗車・支払い完了されたお客様に、
            「<span className={classes.bold}>{mileRate}</span>」を積算いたします。
          </li>
          {isOn && (
            <li>
              通常マイル200円につき1マイルに加え、ボーナスマイルが200円につき1マイル貯まります。
            </li>
          )}
          {isOn && (
            <li>
              通常マイルはご利用後約1～2カ月後にお客様のマイル口座に積算されます。
            </li>
          )}
          <li>
            ボーナスマイル積算は、{bonusAccrualTiming}を予定しております。
          </li>
          <li>
            ボーナスマイルの有効期限は積算月の12カ月後の月末までです。
          </li>
        </>
      );
    }

    // キャンペーン期間外の通常文言
    return (
      <>
        <li>
          本画面にてANAマイレージクラブ会員お客様番号（10桁）をご入力後、
          {props.companyDisplayName}
          を予約・乗車・支払い完了された場合に、「200円（税込）につき1マイル」を積算いたします。
          それ以外の場合は、ご利用になられてもマイルは積算されません
        </li>
        <li>
          マイルはご利用後約1～2カ月後にお客様のマイル口座に積算されます。
        </li>
      </>
    );
  };

  return (
    <>
      <span className={classes.bold}>＜マイルに関するご注意（必ずご確認ください）＞</span>
      <ul className={classes.unorderedList} data-cy={"booking_taxi_amccaution_jp"}>
        {renderHead()}
        <li>
          ご予約成立後に予約をキャンセルされた場合は、マイルは積算されません。
          また、変更・取り消し手数料はマイル積算の対象外となります。
        </li>
        <li>
          ご入力いただいたANAマイレージクラブ会員お客様番号とご名義人が異なる場合は、マイルは積算されません。
        </li>
        <li>
          ご予約完了後のANAマイレージクラブ会員お客様番号の訂正、事後登録はお受けできませんので、
          お申し込みの際はご注意ください。
        </li>
        <li>
          ANAマイレージクラブに関するお問い合わせは
          <Link href={taxiMileHelpURL} target="_blank" className={classes.link}>こちら</Link>
          から。
        </li>
      </ul>
    </>
  )
}

export default AMCCautionJP;
